<template>
  <div>
    <div
      id="surveyEditorContainer"
      v-show="
        globals.isAccessAllowed('LoopOp_Surveys_Read') &&
        globals.isAccessAllowed('LoopOp_Surveys_Update')
      "
    ></div>

    <!-- Lock Icon -->
    <svg style="display: none">
      <symbol
        width="16"
        height="16"
        viewBox="0 0 24 24"
        id="icon-actionsecurity"
      >
        <path
          d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-5 7.723v2.277h-2v-2.277c-.595-.347-1-.984-1-1.723 0-1.104.896-2 2-2s2 .896 2 2c0 .738-.404 1.376-1 1.723zm-5-7.723v-4c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4v4h-8z"
        />
      </symbol>
    </svg>

    <!-- Security Modal -->
    <SurveyElementSecurityModal
      v-if="selectedSurveyElement && surveyElementSecurityModalVisible"
      :modalVisible="surveyElementSecurityModalVisible"
      :surveyElement="selectedSurveyElement"
      :surveyData="surveyData"
      :surveyId="surveyId"
      @saveSecuritySettings="saveSurveyElementSecuritySettings"
      @closeModal="surveyElementSecurityModalVisible = false"
    ></SurveyElementSecurityModal>
  </div>
</template>

<script>
import * as SurveyEditor from "../../../packages/surveyjs-editor/surveyeditor.js";
import "../../../packages/surveyjs-editor/surveyeditor.css";
import * as Survey from "survey-knockout";
import Inputmask from "inputmask";
import "select2";
import "select2/dist/css/select2.css";
import "ace-builds";

import SurveyElementSecurityModal from "./SurveyElementSecurityModal";

const uuidv4 = require("uuid/v4");

export default {
  name: "SurveyEditor",
  components: { SurveyElementSecurityModal },
  created() {
    this.configureSurveyEditor();
    this.initializeEditorDesign();

    if (this.globals.selectedLanguage) {
      this.getEditorLocalization();
      this.globals.getLanguageStrings(this);
    }
  },
  mounted() {
    this.surveyId = parseInt(this.$route.query.id);

    this.lockSurvey(true);
    let heartBeatFunc = () => {
      this.lockSurvey(true);
    };
    this.timer = setInterval(heartBeatFunc, this.heartBeat);

    // if (!this.globals.isProduction this.getKpiList();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.lockSurvey(false);
  },
  destroyed() {
    for (let instance of this.fpInstancesFromSurvey)
      if (instance) instance.destroy();
  },
  methods: {
    calcDesignerHeight() {
      this.designerHeight = $(window).height();
      this.designerHeight -= $("#app-navbar").height() + 240;
    },

    initializeEditor() {
      this.calcDesignerHeight();

      let editorOptions = {
        questionTypes: [
          "text",
          "checkbox",
          "radiogroup",
          "dropdown",
          "comment",
          "rating",
          "html",
          "file",
          "expression",
        ],
        showEmbededSurveyTab: false,
        generateValidJSON: true,
        showTestSurveyTab: true,
        showJSONEditorTab:
          this.globals.isAccessAllowed("LoopOp_SurveyEditor_Read") &&
          this.feature.isEnabled("surveyEditorJSONEditor"),
        showObjectTitles: true,
        showTitlesInExpressions: true,
        isAutoSave: false,
        designerHeight: this.designerHeight + "px",
      };

      // Store previous state and survey if editor instance already exists
      let saveState, currentSurvey;
      if (this.editor) {
        saveState = this.editor.stateValue;
        currentSurvey = this.editor.text;
      }

      this.editor = new SurveyEditor.SurveyEditor(
        "surveyEditorContainer",
        editorOptions
      );
      this.editor.haveCommercialLicense = true;

      if (this.surveyData && this.surveyData.Survey)
        this.editor.text = JSON.stringify(this.surveyData.Survey);

      this.configureToolbox();

      this.editor.saveSurveyFunc = (saveNo, callback) => {
        let survey = this.addUnsetMaxPointsTriggers(
          _.cloneDeep(this.editor.text)
        );
        this.saveSurveyData(survey, saveNo, callback);
      };

      // Use tabs instead of accordion on modal
      this.editor.useTabsInElementEditor = true;

      this.initializeEditorEvents();

      // Restore previous editor state and survey
      if (currentSurvey) {
        this.editor.stateValue = saveState;
        this.updateSaveButtonColor(saveState);
        this.editor.text = currentSurvey;
      }

      // Add reset toolbox button to the toolbar
      this.editor.toolbarItems.splice(3, 0, {
        id: "clearCustomToolbox",
        visible: true,
        title:
          SurveyEditor.editorLocalization.getLocale().ed.clearCustomToolbox ||
          "Reset Toolbox",
        enabled: true,
        action: () => {
          this.editor.toolbox.clearCopiedItems();
          this.editor.toolbox.expandAllCategories();
          localStorage.removeItem("surveyEditorToolboxConfig");
        },
      });

      // Add update button to rerender the whole editor
      this.editor.toolbarItems.splice(3, 0, {
        id: "updateEditorView",
        visible: true,
        title:
          SurveyEditor.editorLocalization.getLocale().ed.updateEditorView ||
          "Update View",
        enabled: true,
        action: () => {
          let text = this.editor.text;
          let saveState = this.editor.stateValue;
          this.editor.render();
          this.editor.text = text;
          this.updateSaveButtonColor(saveState);
        },
      });

      if (!this.globals.isAccessAllowed("LoopOp_SurveyEditor_Update"))
        $(".svd_json_editor_area").prop("disabled", true);

      // Sets the new editor height after the window got resized
      $(window)
        .on("resize", () => {
          this.calcDesignerHeight();
          this.editor.koDesignerHeight(this.designerHeight + "px");
        })
        .resize();
    },

    addUnsetMaxPointsTriggers(surveyString) {
      let surveyJSON = JSON.parse(surveyString);
      let triggers = surveyJSON.triggers;
      let newTriggers = [];

      if (triggers) {
        for (let t of triggers) {
          if (
            t.type === "runexpression" &&
            t.runExpression &&
            _.includes(t.runExpression, "setMaxPoints")
          ) {
            let newTrigger = _.cloneDeep(t);
            newTrigger.expression = "!(" + newTrigger.expression + ")";
            newTrigger.runExpression = _.replace(
              newTrigger.runExpression,
              "setMaxPoints",
              "unsetMaxPoints"
            );
            newTriggers.push(newTrigger);
          }
        }
        surveyJSON.triggers = _.union(triggers, newTriggers);
        surveyString = JSON.stringify(surveyJSON);
      }
      return surveyString;
    },

    removeUnsetMaxPointsTriggers(surveyString) {
      let surveyJSON = JSON.parse(surveyString);
      let triggers = surveyJSON.triggers;

      if (triggers) {
        for (let t of triggers) {
          if (
            t.type === "runexpression" &&
            t.runExpression &&
            _.includes(t.runExpression, "unsetMaxPoints")
          ) {
            _.pull(triggers, t);
          }
        }
        surveyJSON.triggers = triggers;
        surveyString = JSON.stringify(surveyJSON);
      }
      return surveyString;
    },

    lockSurvey(state) {
      let sendData = { Lock: state };
      let url = `api/Surveys/${this.surveyId}/Lock`;
      $.ajax({
        method: "PATCH",
        url: url,
        data: JSON.stringify(sendData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        global: false,
        success: (data) => {
          if (data.Error) this.globals.showErrorSnackbar(data.Error);
        },
        error: () => {
          console.error("Error on PUT in lockSurvey()");
          if (state) this.globals.showErrorSnackbar("Survey lock failed");
          else this.globals.showErrorSnackbar("Survey unlock failed");
        },
      });
    },

    initializeEditorEvents() {
      let generateElementGUIDs = (element) => {
        let elementType = element.getType();
        if (!elementType) return;

        element.guid = uuidv4();

        if (
          elementType === "panel" ||
          elementType === "paneldynamic" ||
          elementType === "page"
        ) {
          let elements =
            elementType === "paneldynamic"
              ? element.templateElements
              : element.elements;

          for (let el of elements) {
            generateElementGUIDs(el);
          }
          return;
        }

        if (element.choices) {
          for (let choice of element.choices) {
            choice.guid = uuidv4();
          }
        }
        if (element.rateValues) {
          for (let value of element.rateValues) {
            value.guid = uuidv4();
          }
        }
        if (element.columns) {
          for (let col of element.columns) {
            col.guid = uuidv4();
          }
        }
        if (element.rows && Array.isArray(element.rows)) {
          for (let row of element.rows) {
            row.guid = uuidv4();
          }
        }
      };

      let generateElementNames = (element) => {
        let elementType = element.getType();
        if (!elementType) return;

        if (elementType === "panel") {
          element.name =
            "g" + _.padStart(this.nextQuestionGroupId.toString(), 5, "0");
          this.nextQuestionGroupId++;
          element.title = element.isCluster
            ? SurveyEditor.editorLocalization.getLocale().qt.cluster ||
              "Cluster"
            : SurveyEditor.editorLocalization.getLocale().qt.questiongroup ||
              "Question Group";
        }

        if (
          elementType === "panel" ||
          elementType === "paneldynamic" ||
          elementType === "page"
        ) {
          let elements =
            elementType === "paneldynamic"
              ? element.templateElements
              : element.elements;

          for (let el of elements) {
            generateElementNames(el);
          }
          return;
        }

        if (
          (element.isCommentOf && element.isCommentOf.length > 0) ||
          _.startsWith(element.name, "c")
        ) {
          let idx = element.parent.elements.indexOf(element);

          // No main question available
          if (idx < 1) {
            element.parent.removeQuestion(element);
            return;
          }
          let main = element.parent.elements[idx - 1];
          // Upper question is not main question
          if (!main.hasCommentText) {
            element.parent.removeQuestion(element);
            return;
          }

          element.name = "c" + main.name.substring(1);
          element.isCommentOf = main.name;
        } else {
          // else, generate new question name
          element.name =
            "q" + _.padStart(this.nextQuestionId.toString(), 5, "0");
          this.nextQuestionId++;
        }
      };

      // Add maxPointsReached to result
      this.editor.onTestSurveyCreated.add((sender, options) => {
        options.survey.onComplete.add((result) => {
          let resultData = result.data;
          let questions = result.getAllQuestions();
          let maxPointsQuestions = [];

          for (let q of questions) {
            if (q.maxPointsReached) {
              maxPointsQuestions.push(q.name);
            }
          }

          if (maxPointsQuestions.length > 0)
            resultData.maxPointsReached = maxPointsQuestions;
          else delete resultData.maxPointsReached;

          result.data = resultData;
        });
      });

      // Adds guids to all new elements in the survey
      this.editor.onQuestionAdded.add((sender, options) => {
        let parent = options.question.parent;
        if (parent.getType() === "page" && parent.elements.length == 2) {
          for (let el of parent.elements) {
            if (el.isCluster) {
              parent.removeElement(options.question);
              el.addQuestion(options.question);
            }
          }
        }

        generateElementGUIDs(options.question);
        generateElementNames(options.question);
        if (
          _.startsWith(options.question.name, "q") &&
          options.question.getType() !== "html"
        )
          options.question.isRequired = true;

        if (
          !options.question.hasTitle ||
          options.question.title === options.question.name
        )
          options.question.title = options.question.name;

        let questionType = options.question.getType();

        if (options.question.choices) {
          for (let item of options.question.choices) {
            if (!item.hasText) item.text = item.value;
          }
        }
        if (options.question.columns) {
          for (var i = 0; i < options.question.columns.length; i++) {
            if (options.question.columns[i].name)
              options.question.columns[i].name = "column" + (i + 1);
            else options.question.columns[i].value = "item" + (i + 1);
          }
        }
        if (options.question.rows) {
          for (var i = 0; i < options.question.rows.length; i++) {
            options.question.rows[i].value = "item" + (i + 1);
            options.question.rows[i].text = options.question.rows[i].value;
          }
        }

        // Do not store files in JSON result as base64 as default
        if (questionType === "file") {
          options.question.storeDataAsText = false;
          options.question.showPreview = true;
          options.question.imageHeight = 150;
        }

        if (
          questionType === "text" ||
          questionType === "comment" ||
          questionType === "matrixdropdown" ||
          questionType === "matrixdynamic"
        ) {
          options.question.translationRequired = true;
        }
      });
      this.editor.onPanelAdded.add((sender, options) => {
        let parent = options.panel.parent;
        if (parent.elements.length > 1 && options.panel.isCluster) {
          parent.removeElement(options.panel);
          this.globals.showErrorSnackbar("No cluster allowed here");
          return;
        }
        if (parent.elements.length == 2) {
          for (let el of parent.elements) {
            if (el.isCluster) {
              parent.removeElement(options.panel);
              el.addQuestion(options.panel);
            }
          }
        }
        let parentType = parent.getType();
        if (
          !(
            parentType === "page" ||
            (parentType === "panel" &&
              parent.isCluster === true &&
              options.panel.isCluster === false)
          )
        ) {
          parent.removeQuestion(options.panel);
          parent.parent.addQuestion(options.panel);
        }
        generateElementGUIDs(options.panel);
        generateElementNames(options.panel);

        let isCluster = !!options.panel.isCluster;
        if (isCluster) {
          options.panel.backgroundColor = "#FFFFFF";
        }
        Survey.JsonObject.metaData.findProperty(
          "panel",
          "backgroundColor"
        ).visible = isCluster;
        Survey.JsonObject.metaData.findProperty("panel", "weight").visible =
          isCluster;
      });
      this.editor.onPageAdded.add((sender, options) => {
        generateElementGUIDs(options.page);
        generateElementNames(options.page);
      });
      this.editor.onItemValueAdded.add((sender, options) => {
        if (options.newItem) {
          options.newItem.guid = uuidv4();
          options.newItem.text = options.newItem.value;
        }
      });
      this.editor.onMatrixColumnAdded.add((sender, options) => {
        options.newColumn.guid = uuidv4();
      });

      this.editor.onElementDoubleClick.add((sender, options) => {
        let elementType = options.element.getType();
        if (elementType === "panel" || elementType === "paneldynamic") return;
        this.editor.showElementEditor(options.element);
      });

      // Set exclusive value for checkboxes on survey test
      this.editor.onTestSurveyCreated.add(function (sender, options) {
        options.survey.onValueChanged.add(function (sender, options) {
          var q = options.question;
          //If question is not defined or question is not checkbox or exclusiveValue does not exist do nothing
          if (!q || q.getType() != "checkbox" || !q.exclusiveValue) return;
          //returns if the value set for the first time or there is nothing to do
          if (!q.prevValue || !options.value) {
            q.prevValue = options.value;
            return;
          }
          var index = options.value.indexOf(q.exclusiveValue);
          //has "None of the above selected"
          if (index > -1) {
            //"None of the above selected" was selected before
            if (q.prevValue.indexOf(q.exclusiveValue) > -1) {
              var value = options.value;
              value.splice(index, 1);
              q.value = value;
            } else {
              //none select just now
              q.value = [q.exclusiveValue];
            }
          }
          q.prevValue = _.clone(q.value);
        });
      });

      // Fill noneGuid property if hasNone is selected
      this.editor.onPropertyValueChanging.add((sender, options) => {
        if (options.propertyName !== "hasNone") return;
        if (options.value) options.obj.noneGuid = uuidv4();
        else options.obj.noneGuid = "";
      });

      // Disable dropping questions or panels in some cases
      this.editor.onDragDropAllow.add((sender, options) => {
        let target = options.target;
        let parent = options.parent;

        // If there is a cluster, no questions outside the cluster allowed
        if (
          parent.getType() === "page" &&
          parent.elements.length === 1 &&
          parent.elements[0].isCluster === true
        )
          options.allow = false;
        // New clusters can only be added to an empty page
        else if (
          parent.getType() === "page" &&
          parent.elements.length > 0 &&
          target.isCluster === true
        )
          options.allow = false;
        // No cluster in cluster and no questiongroup in questiongroup allowed
        else if (target.getType() === "panel" && parent.getType() === "panel") {
          if (parent.isCluster === false) options.allow = false;
          else if (parent.isCluster && target.isCluster) options.allow = false;
        }
      });

      // Predefine filetypes for video upload questions
      this.editor.onPropertyValueChanging.add((sender, options) => {
        if (options.propertyName !== "isVideoUpload") return;

        if (options.value) {
          options.obj.acceptedTypes = "video/*";
          options.obj.isPictureUpload = false;
        }

        // if (options.value) {
        //   let acceptedTypes = options.obj.acceptedTypes || "";
        //   for (let type of this.videoFileTypes) {
        //     if (acceptedTypes.indexOf(type) < 0) {
        //       if (acceptedTypes) acceptedTypes += ", " + type;
        //       else acceptedTypes += type;
        //     }
        //   }
        //   options.obj.acceptedTypes = acceptedTypes;
        // } else {
        //   let acceptedTypes = options.obj.acceptedTypes;
        //   for (let type of this.videoFileTypes) {
        //     let idx = acceptedTypes.indexOf(type);
        //     if (idx < 0) continue;

        //     if (idx == 0) {
        //       acceptedTypes = _.replace(acceptedTypes, type, "");
        //       acceptedTypes = _.trimStart(acceptedTypes, ", ");
        //     } else acceptedTypes = _.replace(acceptedTypes, ", " + type, "");
        //   }
        //   options.obj.acceptedTypes = acceptedTypes;
        // }
      });

      // Predefine filetypes for video upload questions
      this.editor.onPropertyValueChanging.add((sender, options) => {
        if (options.propertyName !== "isPictureUpload") return;
        if (options.value) {
          options.obj.acceptedTypes = "image/*";
          options.obj.isVideoUpload = false;
        }
      });

      // Automatically add and remove comment questions depending on hasCommentText state
      this.editor.onModified.add((sender, options) => {
        // Add or remove comment depending on hasCommentText state
        if (
          options.type === "PROPERTY_CHANGED" &&
          options.name === "hasCommentText"
        ) {
          if (options.newValue === true) {
            let comment = Survey.QuestionFactory.Instance.createQuestion(
              "text",
              "c" + options.target.name.substring(1)
            );
            let idx = options.target.parent.elements.indexOf(options.target);
            options.target.parent.addQuestion(comment, idx + 1);
            comment.isCommentOf = options.target.name;
            comment.visibleIf = options.target.visibleIf;
            comment.isRequired = false;
          } else {
            //Remove comment question
            let comment = options.target.survey.getQuestionByName(
              "c" + options.target.name.substring(1)
            );
            if (!comment) return;
            comment.parent.removeQuestion(comment);
          }
          this.editor.surveyObjects.selectObject(options.target);
        }

        // If question is deleted, also delete comment
        if (
          options.type === "OBJECT_DELETED" &&
          options.target.hasCommentText
        ) {
          let comment = options.target.survey.getQuestionByName(
            "c" + options.target.name.substring(1)
          );
          if (!comment) return;
          comment.parent.removeQuestion(comment);
        } else if (
          options.type === "OBJECT_DELETED" &&
          options.target.isCommentOf
        ) {
          // If comment is deleted, disable hasCommentText on question
          let question = options.target.survey.getQuestionByName(
            options.target.isCommentOf
          );
          if (!question) return;
          question.hasCommentText = false;
          this.editor.surveyObjects.selectObject(question);
        }
      });

      // Adding questions from toolbox
      this.editor.onModified.add((sender, options) => {
        if (options.type !== "ADDED_FROM_TOOLBOX") return;

        // If question is added from toolbox between question with comment, move comment back behind question
        let parent = options.question.parent;
        if (!parent) return;

        let idx = -1;
        for (let i = 0; i < parent.elements.length; i++) {
          if (parent.elements[i].name === options.question.name) {
            if (parent.elements[i + 1] && parent.elements[i + 1].isCommentOf)
              idx = i;
            break;
          }
        }
        if (idx >= 0) {
          let comment = options.question.survey.getQuestionByName(
            parent.elements[idx + 1].name
          );
          if (comment) {
            comment.parent.removeQuestion(comment);
            parent.addQuestion(comment, idx);
          }
        }

        // If question with comment is added from custom toolbox, create comment question
        if (options.question.hasCommentText) {
          let comment = Survey.QuestionFactory.Instance.createQuestion(
            "text",
            "c" + options.question.name.substring(1)
          );
          let idx = parent.elements.indexOf(options.question);
          options.question.parent.addQuestion(comment, idx + 1);
          comment.isCommentOf = options.question.name;
          comment.visibleIf = options.question.visibleIf;
          comment.isRequired = false;
        }
        this.editor.surveyObjects.selectObject(options.question);
      });

      // Dropping question in editor
      this.editor.onModified.add((sender, options) => {
        if (options.type !== "DO_DROP") return;

        if (!options.moveToParent) return;
        // If question is moved, also move comment
        if (options.target.hasCommentText === true && options.source) {
          let comment = options.target.survey.getQuestionByName(
            "c" + options.target.name.substring(1)
          );
          if (!comment) return;
          comment.parent.removeQuestion(comment);
          let newIdx = options.moveToIndex;
          for (let i = 0; i < options.moveToParent.elements.length; i++) {
            if (options.moveToParent.elements[i].name === options.target.name) {
              newIdx = i + 1;
              break;
            }
          }
          options.moveToParent.addQuestion(comment, newIdx);
        } else if (options.target.isCommentOf) {
          // If comment is moved, also move question
          let question = options.target.survey.getQuestionByName(
            options.target.isCommentOf
          );
          if (!question) return;
          question.parent.removeQuestion(question);
          let newIdx = options.moveToIndex;
          for (let i = 0; i < options.moveToParent.elements.length; i++) {
            if (options.moveToParent.elements[i].name === options.target.name) {
              newIdx = i;
              break;
            }
          }
          options.moveToParent.addQuestion(question, newIdx);
        } else if (
          options.moveToParent.elements[options.moveToIndex + 1] &&
          options.moveToParent.elements[options.moveToIndex + 1].isCommentOf
        ) {
          // If other question is moved between question and comment from below, move comment back behind question
          let comment = options.moveToParent.elements[options.moveToIndex + 1];
          if (!comment) return;
          comment.parent.removeQuestion(comment);
          options.moveToParent.addQuestion(comment, options.moveToIndex);
        } else if (
          options.moveToParent.elements[options.moveToIndex] &&
          options.moveToParent.elements[options.moveToIndex].isCommentOf
        ) {
          // If other question is moved between question and comment from above, move comment back behind question
          let comment = options.moveToParent.elements[options.moveToIndex];
          if (!comment) return;
          comment.parent.removeQuestion(comment);
          options.moveToParent.addQuestion(comment, options.moveToIndex - 1);
        }

        // If new question with comment is added from custom toolbox, create comment question
        if (options.target.hasCommentText === true && !options.source) {
          let comment = Survey.QuestionFactory.Instance.createQuestion(
            "text",
            "c" + options.target.name.substring(1)
          );
          let idx = options.moveToIndex + 1;
          if (options.moveToParent.elements[options.moveToIndex].isCommentOf)
            idx++;
          options.moveToParent.addQuestion(comment, idx);
          comment.isCommentOf = options.target.name;
          comment.visibleIf = options.target.visibleIf;
          comment.isRequired = false;
        }

        // Select the question that was moved
        let touchedElement = options.newElement;
        if (!touchedElement) touchedElement = options.target;
        this.editor.surveyObjects.selectObject(
          touchedElement.survey.getQuestionByName(touchedElement.name)
        );
      });

      // Disable fast entry for choices
      this.editor.onSetPropertyEditorOptions.add((sender, options) => {
        options.editorOptions.showTextView = false;
      });

      // Add upload functionality for survey test
      this.editor.onTestSurveyCreated.add((sender, options) => {
        options.survey.onUploadFiles.add((sender, options) => {
          if (!this.globals.isAccessAllowed("LoopOp_Upload_Create")) {
            this.globals.showErrorSnackbar("Permission denied");
            options.callback("error");
            return;
          }

          let files = options.files;
          if (!files || !files[0]) {
            this.globals.showErrorSnackbar("Error on file upload");
            console.error("No upload file available");
            options.callback("error");
            return;
          }

          let uploadCount = files.length;
          let question = sender.getQuestionByName(options.name);
          let callbackData = [];

          files.forEach((file) => {
            let containsImage = _.startsWith(file.type, "image");

            if (question.acceptedTypes) {
              if (!this.globals.isValidFileType(file, question.acceptedTypes)) {
                this.globals.showErrorSnackbar(`Wrong file type: ${file.name}`);
                console.error(
                  `file type mismatch: ${file.name} - accepted types: ${question.acceptedTypes}`
                );
                options.callback("error");
                return;
              }
            }

            let callback = () => {
              let uploadSuccess = (data) => {
                callbackData.push({
                  file: file,
                  content: data[0].DownloadId,
                });
                if (--uploadCount < 1) {
                  options.callback("success", callbackData);
                  this.globals.showSuccessSnackbar(
                    "Attachment upload successful"
                  );
                }
              };
              let uploadError = () => {
                options.callback("error");
              };

              this.globals.uploadFile(file, uploadSuccess, uploadError);
            };
            file.imageUrl = URL.createObjectURL(file);
            if (containsImage)
              this.globals.getImageOrientation(file, (orientation) => {
                this.globals.resetImageOrientation(
                  file,
                  orientation,
                  (data) => {
                    file = data;
                    callback();
                  }
                );
              });
            else callback();
          });
        });

        options.survey.onDownloadFile.add((sender, options) => {
          options.callback("success", "/api/download/" + options.content);
        });
      });

      this.editor.onDesignerSurveyCreated.add((editor, opt) => {
        // Select cluster background color in designer survey
        opt.survey.onUpdatePanelCssClasses.add((sender, options) => {
          if (!options.panel.isCluster) return;
          let pName = options.panel.name;
          let panelContainer = options.cssClasses.panel.container;

          if (panelContainer.indexOf(pName) < 0) {
            panelContainer += " background-" + pName;
            options.cssClasses.panel.container = panelContainer;
            $(".background-" + pName).css(
              "background",
              options.panel.backgroundColor
            );
          }
        });

        // Toggle visibility of panel background property depending on panel type
        opt.survey.onSelectedElementChanged.add((sender, options) => {
          if (!options.newElement || options.newElement.getType() !== "panel")
            return;

          let isCluster = !!options.newElement.isCluster;
          Survey.JsonObject.metaData.findProperty(
            "panel",
            "backgroundColor"
          ).visible = isCluster;
          Survey.JsonObject.metaData.findProperty("panel", "weight").visible =
            isCluster;
        });

        // Store reference of selected survey element
        opt.survey.onSelectedElementChanged.add((sender, options) => {
          if (!options.newElement) return;
          if (!options.newElement.guid) {
            console.error("missing element guid: ", options.newElement);
            this.globals.showErrorSnackbar("Missing element guid");
            return;
          }
          this.selectedSurveyElement = options.newElement;
        });
      });

      this.editor.onTestSurveyCreated.add((editor, opt) => {
        // Select cluster background color in test survey
        opt.survey.onUpdatePanelCssClasses.add((sender, options) => {
          if (!options.panel.isCluster) return;
          let pName = options.panel.name;
          let panelContainer = options.cssClasses.panel.container;

          if (panelContainer.indexOf(pName) < 0) {
            panelContainer += " background-" + pName;
            options.cssClasses.panel.container = panelContainer;
            $(".background-" + pName).css(
              "background",
              options.panel.backgroundColor
            );
          }
        });
      });

      // Mark upper right corner of questions with visibleIf
      this.editor.onDesignerSurveyCreated.add((editor, options) => {
        options.survey.onAfterRenderQuestion.add((survey, options) => {
          if (options.question.visibleIf)
            $(options.htmlElement).addClass("sv_element_with_visibleif");
        });
      });

      // Make visibleIf reactive
      this.editor.onPropertyValueChanging.add((sender, options) => {
        if (options.propertyName !== "visibleIf") return;

        if (options.value)
          $(options.obj.renderedElement).addClass("sv_element_with_visibleif");
        else
          $(options.obj.renderedElement).removeClass(
            "sv_element_with_visibleif"
          );
      });

      // Display point values on element templates
      this.editor.onDesignerSurveyCreated.add((editor, options) => {
        // Points for questions
        options.survey.onAfterRenderQuestion.add((survey, options) => {
          let pointsMax = options.question.pointsMax || 0;

          let pointsHtml = `
            <div class="points-max-on-element">
              <span>${
                SurveyEditor.editorLocalization.getLocale().pe.pointsMax
              }: </span>
              <span class="points-max-value">
                ${pointsMax}
              </span>
            </div>`;

          $(options.htmlElement).append(pointsHtml);
        });

        // Points for panels
        options.survey.onAfterRenderPanel.add((survey, options) => {
          if (!options.panel.pointsMax)
            this.calcPointsMaxOfContainer(options.panel);
          let pointsMax = options.panel.pointsMax || 0;

          let pointsHtml = `
            <div class="points-max-on-element">
              <span>${
                SurveyEditor.editorLocalization.getLocale().pe.pointsMax
              }: </span>
              <span class="points-max-value">
                ${pointsMax ? pointsMax : 0}
              </span>
            </div>`;

          $(options.htmlElement).append(pointsHtml);
        });

        // Points calculation for container elements and survey header
        options.survey.onAfterRenderSurvey.add((survey, options) => {
          this.calcPointsMaxOfContainer(options.survey);

          let pointsMaxSpan = `<span class="points-max-on-survey">(${
            SurveyEditor.editorLocalization.getLocale().pe.pointsMax
          }: 
            ${options.survey.pointsMax})</span>`;

          $(options.htmlElement)
            .find(".sv_container > .panel-heading > h3")
            .append(pointsMaxSpan);
        });
      });
      this.editor.onAdornerRendered.add((editor, options) => {
        if (options.adorner === "choices-label") {
          // Add points to choices
          let answerDivs = $(options.element).find("item-editor");
          let choices = options.question.choices;
          let pointsLabel,
            points = 0,
            maxPoints = 0;

          if (options.context) {
            points = options.context.points || 0;
            if (typeof options.context.maxPoints === "number")
              maxPoints = options.context.maxPoints;
            else maxPoints = options.question.pointsMax || 0;
          }

          pointsLabel = `
              <label style="padding: 0;">(${points}/${maxPoints})</label>
            `;
          $(answerDivs[0].parentElement).append(pointsLabel);
        } else if (options.adorner === "select-choices") {
          // Add points to select choices
          let answerDivs = $(options.element).find("item-editor");
          let choices = options.question.choices;
          let pointsHtml, points, maxPoints;

          for (let i = 0; i < answerDivs.length; i++) {
            points = choices[i].points || 0;
            maxPoints = choices[i].maxPoints || options.question.pointsMax || 0;

            pointsHtml = `
                <label style="padding: 0;">(${points}/${maxPoints})</label>
              `;
            $(answerDivs[i].parentElement).append(pointsHtml);
          }
        }
        // else if (options.adorner === "title") {
        //   // Add points to question title
        //   let maxPoints = options.question.pointsMax || 0;
        //   let pointsLabel = `
        //     <label class="points-max-on-survey" style="padding: 0;">(${maxPoints})</label>
        //   `;
        //   $(options.element).append(pointsLabel);
        // }
      });

      // Add pointsMax value to elements in content list
      this.editor.onGetObjectTextInPropertyGrid.add((editor, options) => {
        let pointsMax = options.obj.pointsMax || 0;
        options.text += " (" + pointsMax + ")";
      });

      // Show question number, text and name on condition select
      this.editor.onConditionQuestionsGetList.add((editor, options) => {
        let surveyQuestionNumbersOff = true;
        if (options.obj.survey)
          surveyQuestionNumbersOff =
            options.obj.survey.showQuestionNumbers === "off";

        options.list.forEach((item) => {
          let questionNumber = "";
          if (item.question) {
            if (surveyQuestionNumbersOff && item.question.customQuestionNumber)
              questionNumber = item.question.customQuestionNumber;
            else if (!surveyQuestionNumbersOff && item.question.no)
              questionNumber = item.question.no;
          }
          item.text = `${questionNumber} ${item.text} (${item.name})`;
        });
      });

      // Toggle question number visibility
      this.editor.onPropertyValueChanging.add((sender, options) => {
        if (options.propertyName !== "showQuestionNumbers") return;

        if (options.value === "off")
          options.obj.questionTitleTemplate =
            "{customQuestionNumber} {title} {require}";
        else options.obj.questionTitleTemplate = "{no} {title} {require}";
      });

      // TODO: Workaround: Disable svd-splitter until it does not work properly
      this.editor.onDesignerSurveyCreated.add((editor, options) => {
        $(document).find("svd-splitter").css("display", "none");
      });

      // Add commentForShopper and shortName to question preview
      this.editor.onDesignerSurveyCreated.add((editor, options) => {
        let survey = options.survey;
        survey.onAfterRenderQuestion.add((survey, options) => {
          if (
            Survey.JsonObject.metaData.findProperty(
              options.question.getType(),
              "commentForShopper"
            )
          ) {
            let comment = options.question.commentForShopper;
            let headerLoc =
              SurveyEditor.editorLocalization.getPropertyName(
                "commentForShopper"
              );
            let commentHtml = `
              <div class="shopper-comment-container big"${
                comment ? "" : ' style="display: none;"'
              }>
                <div class="shopper-comment-header">
                  ${comment ? headerLoc + ":" : ""}
                </div>
                <div class="shopper-comment-content">
                  ${comment ? comment : ""}
                </div>
              </div>`;

            $(options.htmlElement).append(commentHtml);
          }

          if (
            Survey.JsonObject.metaData.findProperty(
              options.question.getType(),
              "shortName"
            )
          ) {
            let shortName = options.question.shortName;
            let shortNameHtml = `
              <div class="short-name-on-question">
                <span>
                  ${shortName ? shortName : ""}
                </span>
              </div>`;

            $(options.htmlElement).append(shortNameHtml);
          }
        });
      });

      // Make shortName and commentForShopper reactive
      this.editor.onPropertyValueChanging.add((sender, options) => {
        if (options.propertyName === "shortName") {
          $(`#${options.obj.id} > .short-name-on-question > span`).text(
            options.value
          );
        } else if (options.propertyName === "commentForShopper") {
          let commentContainer = $(
            `#${options.obj.id} .shopper-comment-container`
          );
          let headerLoc =
            SurveyEditor.editorLocalization.getPropertyName(
              "commentForShopper"
            );
          commentContainer.css("display", options.value ? "" : "none");
          commentContainer.find(".shopper-comment-header").text(headerLoc);
          commentContainer.find(".shopper-comment-content").html(options.value);
        }
      });

      // Updates pointsMax values for container elements after modifications
      this.editor.onModified.add((sender, options) => {
        let pointsManipulationTypes = [
          "DO_DROP",
          "ADDED_FROM_TOOLBOX",
          "OBJECT_DELETED",
          "PROPERTY_CHANGED",
        ];
        if (_.indexOf(pointsManipulationTypes, options.type) < 0) return;
        if (options.type === "PROPERTY_CHANGED" && options.name !== "pointsMax")
          return;

        let element = options.target || options.question;
        if (element) this.calcPointsMaxOfContainer(element.survey.currentPage);
      });

      // Add commentForShopper to questions in test survey
      this.editor.onTestSurveyCreated.add((editor, options) => {
        options.survey.onAfterRenderQuestion.add((survey, options) => {
          if (!options.question.commentForShopper) return;

          let comment = `
          <div class="shopper-comment-container small" 
            style="cursor: pointer;"
            aria-expanded="false"
            data-toggle="collapse" 
            data-target="#instructions-${options.question.name}">
            <div class="shopper-comment-header">
              <span><i class="material-icons md-add">add_circle_outline</i></span>
              <span><i class="material-icons md-remove">remove_circle_outline</i></span>
              <span class="shopper-comment-header-text">
                ${SurveyEditor.editorLocalization.getPropertyName(
                  "commentForShopper"
                )}
              </span>
            </div>
            <div id="instructions-${options.question.name}"
              class="collapse shopper-comment-content">
              ${options.question.commentForShopper}
            </div>
          </div>`;

          $(options.htmlElement).append(comment);
        });
      });

      // Store test survey instance and disable language switch for survey test
      this.editor.onTestSurveyCreated.add((editor, options) => {
        this.testSurvey = options.survey;

        $("#testSurveyLocale").parent().css("display", "none");
      });

      // Configure inputmask depending on inputType property
      this.editor.onTestSurveyCreated.add((editor, options) => {
        options.survey.onAfterRenderQuestion.add((survey, options) => {
          let inputMaskConfig, el, fp;

          for (let type of this.singleInputTypes) {
            el = $(options.htmlElement).find('input[type="' + type + '"]');
            if (el.length < 1) continue;
            if (type !== "number") $(el).prop("type", "text");

            inputMaskConfig = {
              clearIncomplete: true,
            };

            switch (type) {
              case "date":
                fp = flatpickr(
                  "#" + el[0].id,
                  this.globals.flatpickrDateConfig
                );
                fp.setDate(options.question.value, true, "Y-m-d");
                break;
              case "datetime":
                fp = flatpickr(
                  "#" + el[0].id,
                  this.globals.flatpickrDatetimeConfig
                );
                fp.setDate(options.question.value, true, "Y-m-d H:i");
                break;
              case "email":
                inputMaskConfig.alias = "email";
                break;
              case "number":
                inputMaskConfig.alias = "numeric";
                inputMaskConfig.rightAlign = false;
                inputMaskConfig.inputType = "number";
                break;
              case "tel":
                inputMaskConfig.mask = "+(99[9]) 9{2,14}";
                break;
              case "time":
                fp = flatpickr(
                  "#" + el[0].id,
                  this.globals.flatpickrTimeConfig
                );
                fp.setDate(options.question.value, true, "H:i");
                break;
              case "url":
                inputMaskConfig.regex = "(https?|ftp)://.*";
                break;
              case "currency":
                inputMaskConfig.alias = "currency";
                inputMaskConfig.placeholder = "_";
                inputMaskConfig.clearIncomplete = false;
                inputMaskConfig.rightAlign = false;
                inputMaskConfig.tabThrough = true;
                inputMaskConfig.positionCaretOnClick = "select";

                inputMaskConfig.autoUnmask = true;
                inputMaskConfig.onBeforeMask = function (value, opts) {
                  let newValue = value.toString();
                  let radixPointIndex = newValue.indexOf(".");
                  if (radixPointIndex > -1) {
                    if (!newValue[radixPointIndex + 2])
                      newValue = newValue + "0";
                  } else newValue = newValue + ".00";

                  newValue = newValue.replace(".", opts.radixPoint);
                  return newValue;
                };
                inputMaskConfig.onUnMask = function (
                  maskedValue,
                  unmaskedValue,
                  opts
                ) {
                  if (unmaskedValue === "" && opts.nullable === true) {
                    return unmaskedValue;
                  }
                  let stringValue = maskedValue.replace(opts.prefix, "");
                  stringValue = stringValue.replace(
                    new RegExp(Inputmask.escapeRegex(opts.groupSeparator), "g"),
                    ""
                  );
                  if (opts.placeholder.charAt(0) !== "") {
                    stringValue = stringValue.replace(
                      new RegExp(opts.placeholder.charAt(0), "g"),
                      "0"
                    );
                  }

                  if (inputMaskConfig.radixPoint === ",")
                    stringValue = stringValue.replace(",", ".");

                  unmaskedValue = Number.parseFloat(stringValue);
                  return unmaskedValue;
                };

                inputMaskConfig.prefix = survey.currencySymbol + " ";
                inputMaskConfig.groupSeparator =
                  survey.currencyDecimalPoint === "comma" ? "." : ",";
                inputMaskConfig.radixPoint =
                  survey.currencyDecimalPoint === "comma" ? "," : ".";

                if (!survey.getValue(options.question.name))
                  survey.setValue(options.question.name, 0);
            }

            if (fp) {
              $(el[0].parentElement).on("click", (e) => {
                fp.toggle();
              });
              this.fpInstancesFromSurvey.push(fp);
            } else Inputmask(inputMaskConfig).mask(el);
          }
        });
      });

      // Remove email validator if inputType changes to other value
      this.editor.onPropertyValueChanging.add((sender, options) => {
        if (options.propertyName !== "inputType") return;
        if (options.value !== "email") options.obj.validators = [];
      });

      // Make sure that question title and item text are always available in survey JSON
      this.editor.onPropertyValueChanging.add((sender, options) => {
        if (options.propertyName === "title") {
          if (!options.value) options.newValue = options.obj.name;
        }

        if (options.propertyName === "choices") {
          options.newValue = options.value;
          for (let item of options.newValue) {
            if (!item.hasText) item.text = item.value;
          }
        }
      });

      // Change the visible message on empty pages. Needs several updates until surveyjs tries to overwrite the text.
      let changeEmptyPageMessage = () => {
        $("#surveyjs + div.empty-message").html(
          SurveyEditor.editorLocalization.getLocale().survey
            .dropQuestionOnPage || "Step 1: Add cluster<br>Step 2: Add question"
        );
      };
      this.editor.onModified.add((sender, options) => {
        if (
          options.type === "OBJECT_DELETED" &&
          options.target.survey.currentPage.elements.length < 1
        ) {
          changeEmptyPageMessage();
        }
      });
      this.editor.onDesignerSurveyCreated.add((editor, options) => {
        options.survey.onAfterRenderPage.add((survey, options) => {
          if (options.page.elements.length < 1) {
            changeEmptyPageMessage();
          }
        });
      });

      // Hide type change adorner for panels
      this.editor.onElementAllowOperations.add(function (editor, options) {
        let obj = options.obj;
        if (!obj || !obj.page) return;

        if (obj.getType() === "panel") {
          options.allowChangeType = false;
        }
      });

      // Add security button to survey elements
      this.editor.onDefineElementMenuItems.add((sender, options) => {
        let securityButton = {
          name: "security",
          text:
            SurveyEditor.editorLocalization.getLocale().survey.security ||
            "Security",
          hasTitle: true,
          onClick: (element) => {
            this.surveyElementSecurityModalVisible = true;
          },
        };
        options.items.unshift(securityButton);
      });

      // Limit description to 1000 chars and show counter below textarea
      this.editor.onPropertyAfterRender.add((sender, options) => {
        if (options.property.name === "description") {
          let input = $(options.htmlElement)
            .find(".input-group > input.form-control")
            .attr("maxlength", 1000);

          this.$nextTick(() => {
            $(options.htmlElement)
              .find(".modal .modal-body span.description-length-counter")
              .text(`${input.val().length}/${1000}`);
          });
        }
      });
      let debouncedDescriptionCounterUpdateFunc = null;
      this.editor.onPropertyEditorKeyDown.add((sender, options) => {
        if (
          options.propertyName === "description" &&
          options.event.target.tagName === "TEXTAREA"
        ) {
          let target = options.event.target;
          if (debouncedDescriptionCounterUpdateFunc)
            debouncedDescriptionCounterUpdateFunc();
          else {
            debouncedDescriptionCounterUpdateFunc = _.debounce(() => {
              target.nextSibling.innerText = `${target.value.length}/${target.maxLength}`;
              debouncedDescriptionCounterUpdateFunc = null;
            }, 500);
            debouncedDescriptionCounterUpdateFunc();
          }
        }
      });

      // Set dirty flag if survey is edited in JSON editor
      this.editor.jsonEditor.koText.subscribe((newText) => {
        if (this.surveyDirty) return;

        if (!this.surveyDirtyTextStorage) {
          this.surveyDirtyTextStorage = newText;
          return;
        }

        if (
          this.surveyDirtyTextStorage !== newText &&
          this.editor.koViewType() === "editor"
        )
          this.surveyDirty = true;

        this.surveyDirtyTextStorage = newText;
      });
    },

    initializeEditorDesign() {
      var mainColor = $(":root").css("--color-primary-input");
      var mainHoverColor = $(":root").css("--color-primary-input-hover");
      var textColor = "#4a4a4a";
      var headerColor = "#160ce8";
      var headerBackgroundColor = "#4a4a4a";
      var bodyContainerBackgroundColor = "#f8f8f8";

      var defaultThemeColorsSurvey =
        Survey.StylesManager.ThemeColors["default"];
      defaultThemeColorsSurvey["$main-color"] = mainColor;
      defaultThemeColorsSurvey["$main-hover-color"] = mainHoverColor;
      defaultThemeColorsSurvey["$text-color"] = textColor;
      defaultThemeColorsSurvey["$header-color"] = headerColor;
      defaultThemeColorsSurvey["$header-background-color"] =
        headerBackgroundColor;
      defaultThemeColorsSurvey["$body-container-background-color"] =
        bodyContainerBackgroundColor;

      var defaultThemeColorsEditor =
        SurveyEditor.StylesManager.ThemeColors["default"];
      defaultThemeColorsEditor["$primary-color"] = mainColor;
      defaultThemeColorsEditor["$secondary-color"] = mainColor;
      defaultThemeColorsEditor["$primary-hover-color"] = mainHoverColor;
      defaultThemeColorsEditor["$primary-text-color"] = textColor;
      defaultThemeColorsEditor["$selection-border-color"] = mainColor;

      SurveyEditor.StylesManager.applyTheme("bootstrapmaterial");
    },

    configureToolbox() {
      this.editor.toolbox.copiedItemMaxCount = 10;
      this.editor.toolbox.allowExpandMultipleCategories = true;

      let containerName =
        SurveyEditor.editorLocalization.getLocale().ed
          .toolboxContainerCategory || "Container";

      let clusterTemplate = {
        name: "cluster",
        isCopied: false,
        iconName: "icon-panel",
        title:
          SurveyEditor.editorLocalization.getLocale().qt.cluster || "Cluster",
        json: {
          type: "panel",
          isCluster: true,
        },
      };
      let questionGroupTemplate = {
        name: "questiongroup",
        isCopied: false,
        iconName: "icon-panel",
        title:
          SurveyEditor.editorLocalization.getLocale().qt.questiongroup ||
          "Question Group",
        json: {
          type: "panel",
          isCluster: false,
        },
      };
      this.editor.toolbox.addItems([clusterTemplate, questionGroupTemplate]);

      var categories = [
        {
          name: "cluster",
          category: containerName,
        },
        {
          name: "questiongroup",
          category: containerName,
        },
      ];
      this.editor.toolbox.changeCategories(categories);

      // Read custom toolbox items from localStorage
      var customToolboxConfig = localStorage.getItem(
        "surveyEditorCustomToolbox"
      );
      if (customToolboxConfig) {
        let customToolboxConfigObject = JSON.parse(customToolboxConfig);
        for (let item of customToolboxConfigObject) {
          item.category =
            SurveyEditor.editorLocalization.getLocale().ed
              .toolboxCustomCategory || "Custom";
        }
        customToolboxConfig = JSON.stringify(customToolboxConfigObject);
        this.editor.toolbox.copiedJsonText = customToolboxConfig;
      }

      this.editor.toolbox.expandAllCategories();

      this.editor.onCustomElementAddedIntoToolbox.add((sender, options) => {
        // Change name and title of toolbox item
        this.editor.toolbox.changeCategory(
          options.element.name,
          SurveyEditor.editorLocalization.getLocale().ed
            .toolboxCustomCategory || "Custom"
        );
        let element = this.editor.toolbox
          .koCategories()[2]
          .items.filter((item) => item.name === options.element.name)[0];
        element.name = options.element.title;
        element.title = options.element.title;
        this.editor.toolbox.copiedJsonText = this.editor.toolbox.copiedJsonText; // Force toolbox refresh
        this.editor.toolbox.expandAllCategories();

        // Store custom toolbox items to localStorage
        let customToolboxConfig = JSON.parse(
          this.editor.toolbox.copiedJsonText
        );
        for (let item of customToolboxConfig) item.category = "Custom";
        customToolboxConfig = JSON.stringify(customToolboxConfig);
        localStorage.setItem("surveyEditorCustomToolbox", customToolboxConfig);
      });
    },

    // Calculates the next available question id
    findNextQuestionId() {
      let questions = this.editor.survey.getAllQuestions();
      let currentId = 0,
        maxId = 0;
      let idString = "";
      for (let i = 0; i < questions.length; i++) {
        idString = questions[i].name.substring(1);
        currentId = _.parseInt(idString);
        if (currentId > maxId) maxId = currentId;
      }
      this.nextQuestionId = maxId + 1;
    },

    // Calculates the next available question id
    findNextQuestionGroupId() {
      let panels = this.editor.survey.getAllPanels();
      let currentId = 0,
        maxId = 0;
      let idString = "";
      for (let i = 0; i < panels.length; i++) {
        idString = panels[i].name.substring(1);
        currentId = _.parseInt(idString);
        if (currentId > maxId) maxId = currentId;
      }
      this.nextQuestionGroupId = maxId + 1;
    },

    // Calculates the pointsMax value of the given container element
    calcPointsMaxOfContainer(container) {
      let type = container.getType();
      let containerTypes = ["panel", "page", "survey"];

      if (_.indexOf(containerTypes, type) < 0) return; // No container type
      container.pointsMax = 0;
      let elements = type === "survey" ? container.pages : container.elements;

      for (let el of elements) {
        if (_.indexOf(containerTypes, el.getType()) > -1) {
          this.calcPointsMaxOfContainer(el);
        }
        container.pointsMax += el.pointsMax || 0;
      }
    },

    // Requests the current survey data from the server
    getSurveyData() {
      $.ajax({
        method: "GET",
        url: `api/Surveys/${this.surveyId}`,
        success: (data) => {
          if (data.SurveyData) {
            this.surveyData = data.SurveyData; // Store response data from server
            if (this.surveyData.Survey) {
              let survey = this.removeUnsetMaxPointsTriggers(
                JSON.stringify(this.surveyData.Survey)
              );
              this.editor.text = survey;
              this.findNextQuestionId();
              this.findNextQuestionGroupId();
            } else {
              // Adds a guid to the first page of a new survey
              this.editor.survey.visiblePages[0].guid = uuidv4();
              this.editor.survey.focusFirstQuestionAutomatic = false;

              // Fix for showing title in new surveys
              this.editor.survey.title = data.SurveyData.SurveyTitle;
              this.editor.text = _.cloneDeep(this.editor.text);
            }

            this.editor.survey.title = data.SurveyData.SurveyTitle;

            if (this.editor.survey.showQuestionNumbers === "off")
              this.editor.survey.questionTitleTemplate =
                "{customQuestionNumber} {title} {require}";
            else this.editor.survey.questionTitleTemplate = "{title} {require}";

            this.editor.stateValue = "saved";
            this.surveyDirty = false;
            this.surveyDirtyTextStorage = null;

            if (!this.surveyData.ReportingSettings)
              this.surveyData.ReportingSettings = [];
            // if (!this.surveyData.VisibilitySettings)
            //   this.surveyData.VisibilitySettings = [];
          }
        },
        error: () => {
          console.error("Survey data access failed in getSurveyData()");
          this.globals.showErrorSnackbar("Survey data access failed");
        },
      });
    },

    // Requests localization data for the survey editor
    getEditorLocalization() {
      this.getSurveyViewLocalization();

      $.ajax({
        method: "GET",
        url: "api/Language/ComponentTranslation/SurveyEditor",
        success: (data) => {
          if (data && data.length > 0) {
            SurveyEditor.editorLocalization.locales[data[0].LanguageCode] =
              data[0].Translation;
          }
          let newLocale = this.globals.selectedLanguage
            .substring(0, 2)
            .toLowerCase();
          SurveyEditor.editorLocalization.currentLocale = newLocale;

          delete SurveyEditor.editorLocalization.getLocale().pe
            .conditionShowMoreUrl;

          this.initializeEditor();
          if (this.surveyData === null) this.getSurveyData();
        },
        error: () => {
          console.error(
            "Localization data access failed in getEditorLocalization()"
          );
          this.globals.showErrorSnackbar("Localization data access failed");
        },
      });
    },

    // Requests localization data for the survey view
    getSurveyViewLocalization() {
      $.ajax({
        method: "GET",
        url: "api/Language/ComponentTranslation/SurveyView",
        success: (data) => {
          if (data && data.length > 0) {
            Survey.surveyLocalization.locales[data[0].LanguageCode] =
              data[0].Translation;
          }
          let newLocale = this.globals.selectedLanguage
            .substring(0, 2)
            .toLowerCase();
          Survey.surveyLocalization.defaultLocale = newLocale;
        },
        error: () => {
          console.error(
            "Localization data access failed in getSurveyViewLocalization()"
          );
          this.globals.showErrorSnackbar("Localization data access failed");
        },
      });
    },

    // Sends the current survey data to the server
    saveSurveyData(sdata, saveNo, callback) {
      if (!this.globals.isAccessAllowed("LoopOp_Surveys_Update")) {
        this.globals.showErrorSnackbar("Permission denied");
        callback(saveNo, false);
        return;
      }

      this.surveyData.Survey = JSON.parse(sdata);
      if (this.cleanupSecuritySettings() === false) return;

      if (this.surveyDirty) this.surveyData.SurveyDirty = true;
      let data = { SurveyData: this.surveyData };
      if (this.forceSave) data.ForceSave = true;

      $.ajax({
        type: "PUT",
        url: "api/Surveys/" + this.surveyId,
        data: JSON.stringify(data),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (res) => {
          if (
            res &&
            res.Confirmation &&
            res.Confirmation === "EXISTING_CHECKS"
          ) {
            this.globals.$off("SaveSurveyDataYesConfirmation");
            this.globals.$on("SaveSurveyDataYesConfirmation", () => {
              this.forceSave = true;
              this.saveSurveyData(sdata, saveNo, callback);
            });
            this.globals.$off("SaveSurveyDataDialogClosed");
            this.globals.$on("SaveSurveyDataDialogClosed", () => {
              if (!this.forceSave) this.editor.stateValue = "modified";
            });

            this.globals.$emit("openGlobalConfirmationDialog", {
              initiator: "SaveSurveyData",
              confirmationTitle: this.lang.SE0000,
              colorRed: true,
              yesButtonText: this.lang.SE0001,
              noButtonText: this.lang.SE0002,
              htmlText: `<b>
                <p>${this.lang.SE0003}</p>
                <p class="text-uppercase">${this.lang.SE0004}</p>
              </b>`,
            });
          } else callback(saveNo, true);
        },
        error: () => {
          console.error("Error on PUT in saveSurveyData()");
          this.globals.showErrorSnackbar("Survey update failed");
          callback(saveNo, false);
        },
      });
    },

    cleanupSecuritySettings() {
      let elements = _.concat(
        this.editor.survey.getAllQuestions(),
        this.editor.survey.getAllPanels()
      );
      for (let el of elements) {
        if (!el.guid) {
          console.error("missing element guid: ", el);
          this.globals.showErrorSnackbar("Missing element guid");
          return false;
        }
      }

      let cleanupFunc = (setting) => {
        return (
          _.findIndex(
            elements,
            (el) => el.guid.toUpperCase() === setting.ElementGuid
          ) < 0
        );
      };

      _.remove(this.surveyData.ReportingSettings, cleanupFunc);
      _.remove(this.surveyData.SecuritySettings, cleanupFunc);
    },

    // Save security settings of the current survey element
    saveSurveyElementSecuritySettings(settings) {
      if(!this.surveyData.SecuritySettings) this.$set(this.surveyData, 'SecuritySettings', []);
      if(!this.surveyData.ReportingSettings) this.$set(this.surveyData, 'ReportingSettings', []);

      let repIndex = _.findIndex(this.surveyData.ReportingSettings, [
        "ElementGuid",
        this.selectedSurveyElement.guid.toUpperCase(),
      ]);
      if (repIndex > -1)
        this.surveyData.ReportingSettings[repIndex] = settings.reporting;
      else this.surveyData.ReportingSettings.push(settings.reporting);

      let secIndex = _.findIndex(this.surveyData.SecuritySettings, [
        "ElementGuid",
        this.selectedSurveyElement.guid.toUpperCase(),
      ]);
      if (settings.general) {
        if (secIndex > -1)
          this.surveyData.SecuritySettings[secIndex] = settings.general;
        else this.surveyData.SecuritySettings.push(settings.general);
      } else _.pullAt(this.surveyData.SecuritySettings, secIndex);

      this.editor.stateValue = "modified";
    },

    // Requests all KPIs from the server
    getKpiList() {
      $.ajax({
        method: "GET",
        url: "api/Data/kpis",
        success: (data) => {
          let kpiList = [];
          for (var kpi in data) {
            kpiList.push({ value: kpi, text: data[kpi] });
          }

          // Add KPI property to questions
          Survey.JsonObject.metaData.addProperty("question", {
            name: "kpis:multiplevalues",
            choices: kpiList,
          });
          // Add KPI tab to question editor modal
          SurveyEditor.SurveyQuestionEditorDefinition.definition[
            "question"
          ].tabs.push({ name: "kpis" });
        },
        error: () => {
          console.error("KPI data access failed in getKpiList()");
          this.globals.showErrorSnackbar("KPI data access failed");
        },
      });
    },

    updateSaveButtonColor(state) {
      if (state === "saved")
        $("#svd-save > button").css("background-color", "green");
      if (state === "modified")
        $("#svd-save > button").css("background-color", "red");
      if (state === "saving")
        $("#svd-save > button").css("background-color", "yellow");
    },

    configureSurveyEditor() {
      if (SurveyEditor.editorConfigDone) return;

      // Add points to answers
      Survey.JsonObject.metaData.addClass(
        "itemvaluesWithPoints",
        ["points:number", "isPositive:boolean"],
        null,
        "itemvalue"
      );
      Survey.JsonObject.metaData.addProperty(
        "selectbase",
        "choices:itemvalues"
      );
      let property1 = Survey.JsonObject.metaData.findProperty(
        "selectbase",
        "choices"
      );
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      Survey.JsonObject.metaData.addProperty("rating", "rateValues:itemvalues");
      property1 = Survey.JsonObject.metaData.findProperty(
        "rating",
        "rateValues"
      );
      property1.typeValue = "itemvaluesWithPoints";
      property1.className = "itemvaluesWithPoints";

      // Add maxPoints to answers of radiogroups
      Survey.JsonObject.metaData.addClass(
        "itemvaluesWithPointsAndMaxPoints",
        ["points:number", "maxPoints:number", "isPositive:boolean"],
        null,
        "itemvalue"
      );
      Survey.JsonObject.metaData.addProperty(
        "radiogroup",
        "choices:itemvalues"
      );
      let property2 = Survey.JsonObject.metaData.findProperty(
        "radiogroup",
        "choices"
      );
      property2.typeValue = "itemvaluesWithPointsAndMaxPoints";
      property2.className = "itemvaluesWithPointsAndMaxPoints";

      // Add data protection property to questions
      Survey.JsonObject.metaData.addProperty("question", {
        name: "observeDataProtection:boolean",
      });
      SurveyEditor.SurveyQuestionEditorDefinition.definition[
        "question"
      ].properties.push({ name: "observeDataProtection" });

      // Add points properties to questions
      Survey.JsonObject.metaData.addProperty("question", {
        name: "pointsMin:number",
      });
      SurveyEditor.SurveyQuestionEditorDefinition.definition[
        "question"
      ].properties.push({ name: "pointsMin" });
      Survey.JsonObject.metaData.addProperty("question", {
        name: "pointsMax:number",
      });
      SurveyEditor.SurveyQuestionEditorDefinition.definition[
        "question"
      ].properties.push({ name: "pointsMax" });

      // Add video upload property to file questions
      Survey.JsonObject.metaData.addProperty("file", {
        name: "isVideoUpload:boolean",
      });

      // Add picture upload property to file questions
      Survey.JsonObject.metaData.addProperty("file", {
        name: "isPictureUpload:boolean",
      });

      // Add short text property for reporting
      Survey.JsonObject.metaData.addProperty("question", {
        name: "shortName",
        type: "shortname",
        isRequired: true,
      });
      let ShortTextEditor = {
        render: (editor, htmlElement) => {
          var input = document.createElement("input");
          input.className = "form-control svd_editor_control";
          input.type = "text";
          input.maxLength = 5;
          input.style.width = "100%";
          htmlElement.appendChild(input);
          input.onchange = () => {
            editor.koValue(input.value);
          };
          editor.onValueUpdated = (newValue) => {
            input.value = editor.koValue() || "";
          };
          input.value = editor.koValue() || "";
        },
      };
      SurveyEditor.SurveyPropertyEditorFactory.registerCustomEditor(
        "shortname",
        ShortTextEditor
      );
      SurveyEditor.SurveyQuestionEditorDefinition.definition.question.properties.splice(
        1,
        0,
        "shortName"
      );

      // Add short question text property for filenames
      Survey.JsonObject.metaData.addProperty("question", {
        name: "questionTextShort",
        type: "questionTextShort",
        isRequired: true,
      });
      let questionTextShortEditor = {
        render: (editor, htmlElement) => {
          var input = document.createElement("input");
          input.className = "form-control svd_editor_control";
          input.type = "text";
          input.maxLength = 50;
          input.style.width = "100%";
          htmlElement.appendChild(input);
          input.onchange = () => {
            input.value = input.value.replace(/ /g, "_");
            editor.koValue(input.value);
          };
          input.onkeypress = (e) => {
            if (e.which == 32) return false;
          };
          editor.onValueUpdated = (newValue) => {
            input.value = editor.koValue() || "";
          };
          input.value = editor.koValue() || "";
        },
      };
      SurveyEditor.SurveyPropertyEditorFactory.registerCustomEditor(
        "questionTextShort",
        questionTextShortEditor
      );
      SurveyEditor.SurveyQuestionEditorDefinition.definition.file.properties.splice(
        0,
        0,
        "questionTextShort"
      );

      // Add color selection property for clusters
      Survey.JsonObject.metaData.addProperty("panel", {
        name: "backgroundColor",
        type: "backgroundColor",
      });
      let colorEditor = {
        render: (editor, htmlElement) => {
          var input = document.createElement("input");
          input.className = "form-control svd_editor_control";
          input.type = "color";
          input.style.width = "100%";
          htmlElement.appendChild(input);
          input.onchange = () => {
            editor.koValue(input.value);
          };
          editor.onValueUpdated = (newValue) => {
            input.value = editor.koValue() || "";
          };
          input.value = editor.koValue() || "";
        },
      };
      SurveyEditor.SurveyPropertyEditorFactory.registerCustomEditor(
        "backgroundColor",
        colorEditor
      );

      // Add isCluster flag to panels
      Survey.JsonObject.metaData.addProperty("panel", {
        name: "isCluster:boolean",
        default: false,
      });
      Survey.JsonObject.metaData.findProperty(
        "panel",
        "isCluster"
      ).readOnly = true;

      // Add translationRequired flag to questions that can contain text input
      Survey.JsonObject.metaData.addProperty("text", {
        name: "translationRequired:boolean",
      });
      Survey.JsonObject.metaData.addProperty("comment", {
        name: "translationRequired:boolean",
      });
      Survey.JsonObject.metaData.addProperty("matrixdropdownbase", {
        name: "translationRequired:boolean",
      });

      // Add isShowOnlySelectedAnswer flag to selectbase questions
      Survey.JsonObject.metaData.addProperty("selectbase", {
        name: "isShowOnlySelectedAnswer:boolean",
        default: false,
      });

      // Add comment properties for creating comment questions
      Survey.JsonObject.metaData.addProperty("text", "isCommentOf");
      Survey.JsonObject.metaData.findProperty(
        "text",
        "isCommentOf"
      ).readOnly = true;
      Survey.JsonObject.metaData.addProperty("comment", "isCommentOf");
      Survey.JsonObject.metaData.findProperty(
        "comment",
        "isCommentOf"
      ).readOnly = true;
      Survey.JsonObject.metaData.addProperty("selectbase", {
        name: "hasCommentText:boolean",
      });

      // Add commentForShopper property for all questions
      Survey.JsonObject.metaData.addProperty(
        "question",
        "commentForShopper:html"
      );

      // Limit description to 1000 chars
      let descriptionModalEditor = {
        afterRender: function (modalEditor, htmlElement) {
          if (modalEditor.property.name === "description") {
            htmlElement.maxLength = 1000;
            let counter = document.createElement("span");
            counter.innerText = `${htmlElement.value.length}/${htmlElement.maxLength}`;
            counter.className = "help-block description-length-counter";
            htmlElement.parentNode.insertBefore(
              counter,
              htmlElement.nextSibling
            );
          }
        },
      };
      SurveyEditor.SurveyPropertyModalEditor.registerCustomWidget(
        "text",
        descriptionModalEditor
      );

      // Add exclusive value selection for checkbox questions
      class SurveyPropertyDefaultCheckboxValueEditor extends SurveyEditor.SurveyPropertyDefaultValueEditor {
        constructor(property) {
          super(property);
        }
        buildQuestionJson() {
          var qjson = super.buildQuestionJson();
          qjson.type = "radiogroup";
          return qjson;
        }
      }
      SurveyEditor.SurveyPropertyEditorFactory.registerEditor(
        "checkboxValue",
        function (property) {
          return new SurveyPropertyDefaultCheckboxValueEditor(property);
        }
      );
      Survey.JsonObject.metaData.addProperty(
        "checkbox",
        "exclusiveValue:checkboxValue"
      );

      SurveyEditor.removeAdorners(["rating-item"]);

      // Add custom question numbers
      Survey.JsonObject.metaData.addProperty("question", {
        name: "customQuestionNumber",
        default: 0,
      });

      // Add guid property to questions, pages and panels and set to readonly
      Survey.JsonObject.metaData.addProperty("question", "guid");
      Survey.JsonObject.metaData.addProperty("panelbase", "guid");
      Survey.JsonObject.metaData.addProperty("matrixdropdowncolumn", "guid");
      Survey.JsonObject.metaData.addProperty("itemvalue", "guid");
      Survey.JsonObject.metaData.addProperty("checkbox", "noneGuid");
      Survey.JsonObject.metaData.findProperty(
        "question",
        "guid"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "panelbase",
        "guid"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "checkbox",
        "noneGuid"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "itemvalue",
        "guid"
      ).visible = false;

      // Make question names readonly
      Survey.JsonObject.metaData.findProperty(
        "question",
        "name"
      ).readOnly = true;
      Survey.JsonObject.metaData.findProperty(
        "itemvalue",
        "value"
      ).readOnly = true;
      Survey.JsonObject.metaData.findProperty(
        "itemvaluesWithPoints",
        "value"
      ).readOnly = true;
      Survey.JsonObject.metaData.findProperty(
        "panelbase",
        "name"
      ).readOnly = true;
      Survey.JsonObject.metaData.findProperty(
        "file",
        "storeDataAsText"
      ).readOnly = true;
      Survey.JsonObject.metaData.findProperty(
        "matrixdropdowncolumn",
        "name"
      ).readOnly = true;

      // Add weight per cluster
      Survey.JsonObject.metaData.addProperty("panel", {
        name: "weight",
        type: "percentage",
      });
      let percentageEditor = {
        render: (editor, htmlElement) => {
          var input = document.createElement("input");
          input.className = "form-control svd_editor_control";
          input.type = "number";
          input.step = 0.001;
          input.max = 99.99999;
          input.min = 0;
          input.style.width = "100%";
          htmlElement.appendChild(input);
          input.onchange = () => {
            if (input.valueAsNumber > input.max) input.value = input.max;
            else if (input.valueAsNumber < input.min) input.value = input.min;
            editor.koValue(parseFloat(input.value));
          };
          editor.onValueUpdated = (newValue) => {
            input.value = editor.koValue() || "";
          };
          input.value = editor.koValue() || "";
        },
      };
      SurveyEditor.SurveyPropertyEditorFactory.registerCustomEditor(
        "percentage",
        percentageEditor
      );

      // Add securitySettings object to questions and panels
      Survey.JsonObject.metaData.addProperty("question", "securitySettings");
      Survey.JsonObject.metaData.findProperty(
        "question",
        "securitySettings"
      ).visible = false;
      Survey.JsonObject.metaData.addProperty("panel", "securitySettings");
      Survey.JsonObject.metaData.findProperty(
        "panel",
        "securitySettings"
      ).visible = false;

      // Limit choices of inputType property
      Survey.JsonObject.metaData.findProperty(
        "text",
        "inputType"
      ).choicesValue = [
        "date",
        "datetime",
        "email",
        "number",
        "password",
        "range",
        "tel",
        "text",
        "time",
        "url",
        "currency",
      ];

      // Add properties for currency inputs
      Survey.JsonObject.metaData.addProperty("survey", {
        name: "currencySymbol",
        default: "€",
      });
      Survey.JsonObject.metaData.addProperty("survey", {
        name: "currencyDecimalPoint",
        default: "comma",
      });
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "currencyDecimalPoint"
      ).choicesValue = ["comma", "point"];

      // Register functions for expression trigger and add maxPointsReached for selectbase questions
      Survey.FunctionFactory.Instance.register("setMaxPoints", (params) => {
        if (params.length < 1 || !this.testSurvey) return;
        for (let i = 0; i < params.length; i++) {
          let q = this.testSurvey.getQuestionByName(params[i]);
          if (q) q.maxPointsReached = true;
        }
      });
      Survey.FunctionFactory.Instance.register("unsetMaxPoints", (params) => {
        if (params.length < 1 || !this.testSurvey) return;
        for (let i = 0; i < params.length; i++) {
          let q = this.testSurvey.getQuestionByName(params[i]);
          if (q && q.maxPointsReached) q.maxPointsReached = false;
        }
      });
      Survey.JsonObject.metaData.addProperty("selectbase", {
        name: "maxPointsReached:boolean",
        default: false,
      });
      Survey.JsonObject.metaData.findProperty(
        "selectbase",
        "maxPointsReached"
      ).visible = false;

      // Remove unnecessary features
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "title"
      ).visible = false;
      if (this.feature.isDisabled("surveyQuizTimers")) {
        Survey.JsonObject.metaData.findProperty(
          "survey",
          "showTimerPanel"
        ).visible = false;
        Survey.JsonObject.metaData.findProperty(
          "survey",
          "showTimerPanelMode"
        ).visible = false;
        Survey.JsonObject.metaData.findProperty(
          "survey",
          "maxTimeToFinish"
        ).visible = false;
        Survey.JsonObject.metaData.findProperty(
          "survey",
          "maxTimeToFinishPage"
        ).visible = false;
        Survey.JsonObject.metaData.findProperty(
          "page",
          "maxTimeToFinish"
        ).visible = false;
      }
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "completedBeforeHtml"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "locale"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "pageNextText"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "pagePrevText"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "startSurveyText"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "completeText"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "showNavigationButtons"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "showPrevButton"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "storeOthersAsComment"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "sendResultOnPageNext"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "cookieName"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "maxOthersLength"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "checkErrorsMode"
      ).visible = false;

      Survey.JsonObject.metaData.findProperty(
        "selectbase",
        "choicesByUrl"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "selectbase",
        "hasComment"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "question",
        "commentText"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "question",
        "useDisplayValuesInTitle"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "rating",
        "hasComment"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "selectbase",
        "hasOther"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "selectbase",
        "otherText"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "selectbase",
        "otherErrorText"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "selectbase",
        "storeOthersAsComment"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "checkbox",
        "hasNone"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "checkbox",
        "noneText"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "checkbox",
        "hasSelectAll"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "checkbox",
        "selectAllText"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "rating",
        "correctAnswer"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "questionStartIndex"
      ).visible = false;
      Survey.JsonObject.metaData.findProperty(
        "survey",
        "questionTitleTemplate"
      ).visible = false;

      _.remove(
        SurveyEditor.SurveyQuestionEditorDefinition.definition["file"]
          .properties,
        (p) => {
          return p.name === "storeDataAsText";
        }
      );

      // Remove imagepicker from questionconverter
      let convertInfo = SurveyEditor.QuestionConverter.convertInfo;
      for (let type in convertInfo) {
        _.pull(convertInfo[type], "imagepicker");
      }

      SurveyEditor.editorConfigDone = true;
    },
  },
  watch: {
    "globals.selectedLanguage"(newLanguage) {
      if (!newLanguage) return;
      this.getEditorLocalization();
      this.globals.getLanguageStrings(this);
    },
    "globals.currentUserInfo"(newValue) {
      if (!newValue.Policies) return;
      this.initializeEditor(); // Avoids race condition for JSON Editor access
    },
    "editor.state"(newState) {
      if (!newState) return;
      this.updateSaveButtonColor(newState);
    },
  },
  data() {
    return {
      editorUrl: "",
      surveyId: -1,
      surveyData: null,
      testSurvey: null,
      designerSurvey: null,
      editor: null,
      heartBeat: 30000,
      timer: null,
      designerHeight: 600,
      nextQuestionId: 0,
      nextQuestionGroupId: 0,
      surveyDirty: false,
      surveyDirtyTextStorage: null,
      forceSave: false,
      selectedSurveyElement: null,
      surveyElementSecurityModalVisible: false,
      fpInstancesFromSurvey: [],
      // videoFileTypes: [".avi", ".mov", ".mp4", ".mpg", ".wmv", ".3gp"],
      singleInputTypes: [
        "date",
        "datetime",
        "email",
        "number",
        "tel",
        "time",
        "url",
        "currency",
      ],
      lang: {
        SE0000: "Save survey",
        SE0001: "Yes",
        SE0002: "No",
        SE0003:
          "ATTENTION: There are already existing checks based on this survey. Do you really want to save?",
        SE0004: "All affected checks will be changed by this action",
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#surveyEditorContainer {
  text-align: left;
}

#surveyEditorContainer table {
  table-layout: auto;
}

#surveyEditorContainer .modal-dialog {
  max-width: 1000px;
  width: 800px;
}

/* Fix horizontal scrollbar on modal and margin between form-groups */
#surveyEditorContainer .modal-dialog .form-group {
  overflow: visible;
}

/* Fix modal dropdown look */
#surveyEditorContainer .modal-dialog .form-group select {
  appearance: none !important;
}

/* Make checkbox lists on modals appear in vertical order */
#surveyEditorContainer .sjs-cb-wrapper {
  display: block;
}

/* Optimize look of survey test */
#surveyjsExample {
  background: white;
  max-height: calc(100vh - 170px);
  overflow: auto;
}
#surveyjsExample .sv_qstn,
#surveyjsExample .sv_p_container {
  border: 1px solid #e7eaec;
  padding: 20px 9px;
  margin-bottom: 38px;
}
#surveyjsExample .sv_p_container {
  border: 3px solid #d5d8da;
}

/* Fix text color for selected answer on rating questions */
#surveyjsExample .sv_qstn .btn-group > label.btn-secondary.active {
  color: white;
}

#surveyEditorContainer .sv_p_container {
  border-width: 3px;
}

#surveyEditorContainer
  .svd_questions_editor
  .sv_element_with_visibleif::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-width: 16px 0 0 16px;
  border-style: solid;
  border-color: var(--color-primary-input) #fff;
}

/* Set default background color of questions */
#surveyjsExample .sv_qstn,
#surveyEditorContainer .sv_qstn {
  background: white;
}

/* Optimize look of toolbox */
.svd_container .svd_toolbox .svd_toolbox_item {
  background-color: white;
  padding-left: 23px !important;
}
.svd_container .svd_toolbox .panel-info [role="tabpanel"] {
  padding-left: 0 !important;
  font-size: 16px;
}

/* Shopper comment */
#surveyEditorContainer .shopper-comment-container {
  padding: 10px 0 0 0;
}
#surveyEditorContainer .shopper-comment-header {
  font-size: 14px;
  padding-bottom: 5px;
}
#surveyEditorContainer .shopper-comment-content {
  padding-left: 10px;
}
#surveyEditorContainer .shopper-comment-header .material-icons {
  font-size: 22px;
}
#surveyEditorContainer .shopper-comment-container .material-icons {
  width: 20px;
  position: absolute;
}
#surveyEditorContainer .shopper-comment-header-text {
  padding-left: 30px;
}
#surveyEditorContainer
  .shopper-comment-container[aria-expanded="true"]
  .md-add {
  display: none;
}
#surveyEditorContainer
  .shopper-comment-container[aria-expanded="false"]
  .md-remove {
  display: none;
}

/* Increase description font size */
#surveyEditorContainer .small {
  font-size: 100%;
}

/* Darker label color in form groups */
#surveyEditorContainer .form-group .checkbox label,
#surveyEditorContainer .form-group .radio label,
#surveyEditorContainer .form-group label {
  color: rgb(80, 80, 80);
}

/* Fix property list with */
#surveyEditorContainer .svd_object_editor td {
  max-width: 100px;
}

/* Add border for all form controls that are not inside survey instance */
#surveyEditorContainer .form-control {
  border: 1px solid lightgray;
}
#surveyEditorContainer .sv_container .form-control {
  border: none;
}

#surveyEditorContainer .form-control:disabled {
  background: rgb(240, 240, 240);
}

/* Fix for select arrow appearance */
#surveyEditorContainer .form-group select.form-control {
  appearance: none !important;
}
#surveyEditorContainer .svd_properties_grid .svd_custom_select::before {
  margin-top: -2px;
}
#surveyEditorContainer
  .svd_properties_grid
  .modal-dialog
  .svd_custom_select::before {
  margin-top: 0;
}

/* Increase font-size of titles */
#surveyEditorContainer h3 {
  font-weight: 400;
}
#surveyEditorContainer h4 {
  font-size: 22px;
}
#surveyEditorContainer h5 {
  font-size: 16px;
}

/* Increase space between radiobuttons */
#surveyEditorContainer .radio + .radio {
  margin-top: 10px;
}

/* Increase space between inputs on modal */
#surveyEditorContainer .modal-dialog label {
  margin-top: 10px;
}

/* Fix add button position for condition creator */
#surveyEditorContainer
  .modal-dialog
  .propertyeditor-condition
  input[type="button"] {
  top: 2px;
}
#surveyEditorContainer
  .svd_properties_grid
  .modal-dialog
  .propertyeditor-condition
  input[type="button"] {
  top: 0;
}

/* Increase font-size for dropdown items */
#surveyEditorContainer .svda-select-items-collection {
  font-size: 18px;
}

#surveyEditorContainer .description-length-counter {
  margin: 0;
}

.short-name-on-question {
  position: absolute;
  right: 10px;
  top: 25px;
  font-size: 14px;
  font-weight: 400;
}

.points-max-on-element {
  position: absolute;
  right: 10px;
  top: 5px;
  font-size: 14px;
  font-weight: 400;
}

.points-max-on-survey {
  font-size: 14px;
  font-weight: 400;
}

/* Fix toolbox header width for some screen sizes */
.svd-toolbox-category-header {
  display: inline-block;
  width: 100%;
}

/* Fix line height of empty page message */
#surveyjs + div.empty-message {
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// SurveyEditor.vue?1989f278